import { cva, type VariantProps } from "class-variance-authority";
import { clsx } from "clsx";
import { type PropsWithChildren } from "react";

const textStyles = cva("", {
  variants: {
    variant: {
      base: "text-base text-interface-neutral-4",
      primary: "text-lg font-bold text-interface-neutral-6",
      secondary: "text-lg font-bold text-interface-neutral-5",
      positive: "text-base font-bold text-interface-positive-3",
      negative: "text-base font-bold text-interface-negative-3"
    }
  },
  defaultVariants: {
    variant: "base"
  }
});

type HeaderTextProps = VariantProps<typeof textStyles> & {
  className?: string;
};

export const BasketHeaderText = ({
  children,
  className,
  variant
}: PropsWithChildren<HeaderTextProps>) => {
  return (
    <span className={clsx(textStyles({ variant }), className)}>{children}</span>
  );
};
